import React from "react";
import { useIntl } from "react-intl";

import FormLayout from "components/FormLayout";
import SetPasswordForm from "../setPasswordForm";

function SetPasswordLayout() {
  const intl = useIntl();

  return (
    <FormLayout label={intl.messages["loginScene.login.logoUpdatePwdLabel"]}>
      <SetPasswordForm />
    </FormLayout>
  );
}

export default SetPasswordLayout;
